import { render } from "./UpdateLessons.vue?vue&type=template&id=624c37b7"
import script from "./UpdateLessons.vue?vue&type=script&lang=js"
export * from "./UpdateLessons.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/cafemano-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__